<template>
    <div id="mobileMenu" ref="mobileMenu">
        <transition name="fade">
            <div v-show="menuBackdrop"
                 class="fixed top-0 text-black w-full h-full mobile-menu" style="z-index: 100">

                <div class="flex h-full">
                    <transition name="slide-right">
                        <div class="bg-white w-4/6" v-if="showMobileMenu">
                            <div class="text-center p-8 px-20">
                                <div class="grid justify-items-center">
                                    <logo></logo>
                                </div>
                            </div>

                            <div class="text-purple-900">
                                <button class="block p-5 w-full uppercase" v-for="(item, key) in menu"
                                        @click="goTo(item.link)"
                                        :key="key">
                                    {{ $t(item.name) }}
                                </button>

                                <button class="block p-5 w-full uppercase" v-if="statusPage" @click="open(statusPage, '_blank')">
                                    {{ $t('status') }}
                                </button>

                                <button class="block p-5 w-full uppercase" @click="goTo('/clients/my-account')">
                                    {{ $t('my_account') }}
                                </button>
                            </div>
                        </div>
                    </transition>

                    <div class="w-2/6" @click="closeMobile()">
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>


<style>

</style>

<script>
    export default {
        name: 'mobile-menu',

        props: {
            menu: {
                type: Array,
                default: () => {
                    return []
                }
            }
        },

        data() {
            return {
                showMobileMenu: false,
                menuBackdrop: false,
                buttons: [],
                statusPage: window.appConfig.dash.pages.status
            }
        },

        mounted() {
            this.startGestureDetector();
        },

        methods: {
            startGestureDetector() {
                let touchstartX = 0;
                let touchendX = 0;

                const gestureZone = this.$refs.mobileMenu;

                gestureZone.addEventListener('touchstart', (event) => {
                    touchstartX = event.changedTouches[0].screenX;
                }, {
                    passive: false
                });

                gestureZone.addEventListener('touchend', (event) => {
                    touchendX = event.changedTouches[0].screenX;

                    if (touchendX <= touchstartX) {
                        this.closeMobile();
                    }
                }, {
                    passive: false
                });
            },

            openMobile() {
                this.menuBackdrop = true;
                this.showMobileMenu = true;
            },

            closeMobile() {
                this.showMobileMenu = false;

                setTimeout(() => {
                    this.menuBackdrop = false;
                }, 200)
            },

            goTo(link) {
                this.$emit('go-to', link);
                this.closeMobile();
            },

            open(link) {
                window.open(link, '_blank');
            }
        }
    }
</script>